module.exports = __webpack_public_path__ + "static/media/family_08.f2aae70b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_08.jpg
// module id = 5840
// module chunks = 0